/**
 * Rosada Cart Upsell — Subscribe&Save, Bundle Add-on, Free Shipping Bar
 * Vanilla JS, no deps. Uses Shopify Cart-API only.
 */
(function () {
  'use strict';

  var CART = {
    update: '/cart/update.js',
    change: '/cart/change.js',
    add:    '/cart/add.js',
    get:    '/cart.js'
  };

  function fetchJSON(url, opts) {
    return fetch(url, Object.assign({ credentials: 'same-origin', headers: { 'Content-Type': 'application/json' } }, opts || {}))
      .then(function (r) { return r.json(); });
  }

  function reload() {
    window.dispatchEvent(new CustomEvent('rosada:cart:updated'));
    window.location.reload();
  }

  /* ── Free Shipping Progress Bar ─────────────────────────────────── */
  function updateShippingBar() {
    var bar = document.querySelector('[data-shipping-bar]');
    if (!bar) return;
    var threshold = parseInt(bar.dataset.threshold, 10) || 8000; /* in cents */
    fetchJSON(CART.get).then(function (cart) {
      var fill = bar.querySelector('[data-shipping-fill]');
      var msg  = bar.querySelector('[data-shipping-msg]');
      var pct  = Math.min(100, (cart.total_price / threshold) * 100);
      if (fill) fill.style.width = pct + '%';
      if (msg) {
        if (cart.total_price >= threshold) {
          msg.textContent = '✦ Gratis-Versand freigeschaltet';
          bar.classList.add('rct-bar--reached');
        } else {
          var remaining = (threshold - cart.total_price) / 100;
          msg.textContent = 'Noch CHF ' + remaining.toFixed(2) + ' für Gratis-Versand';
          bar.classList.remove('rct-bar--reached');
        }
      }
    });
  }

  /* ── Subscribe & Save Toggle ─────────────────────────────────────── */
  function bindSubscribeToggle() {
    document.querySelectorAll('[data-subscribe-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.dataset.busy === '1') return;
        btn.dataset.busy = '1';
        btn.classList.add('rct-toggle--loading');

        var line = parseInt(btn.dataset.line, 10);
        var sellingPlan = btn.dataset.sellingPlan;
        var isActive = btn.classList.contains('rct-toggle--on');
        var body = isActive
          ? { line: line, selling_plan: '' }
          : { line: line, selling_plan: sellingPlan };

        fetchJSON(CART.change, { method: 'POST', body: JSON.stringify(body) })
          .then(function () { reload(); })
          .catch(function () { btn.dataset.busy = '0'; btn.classList.remove('rct-toggle--loading'); });
      });
    });
  }

  /* ── Bundle Cross-Sell ───────────────────────────────────────────── */
  function bindCrossSell() {
    document.querySelectorAll('[data-cross-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.dataset.busy === '1') return;
        btn.dataset.busy = '1';
        btn.textContent = 'Wird hinzugefügt...';
        var variantId = btn.dataset.variantId;
        fetchJSON(CART.add, { method: 'POST', body: JSON.stringify({ id: variantId, quantity: 1 }) })
          .then(function () { reload(); })
          .catch(function () { btn.dataset.busy = '0'; btn.textContent = 'Erneut versuchen'; });
      });
    });
  }

  /* ── Bundle Up (12 → 24/36) ──────────────────────────────────────── */
  function bindBundleUp() {
    document.querySelectorAll('[data-bundle-up]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.dataset.busy === '1') return;
        btn.dataset.busy = '1';
        btn.textContent = 'Wird hochgestuft...';
        var line = parseInt(btn.dataset.line, 10);
        var newVariant = btn.dataset.targetVariant;
        /* First change quantity to 0 (remove), then add new variant */
        fetchJSON(CART.change, { method: 'POST', body: JSON.stringify({ line: line, quantity: 0 }) })
          .then(function () { return fetchJSON(CART.add, { method: 'POST', body: JSON.stringify({ id: newVariant, quantity: 1 }) }); })
          .then(function () { reload(); })
          .catch(function () { btn.dataset.busy = '0'; btn.textContent = 'Erneut versuchen'; });
      });
    });
  }

  /* ── Init ─────────────────────────────────────────────────────────── */
  function init() {
    updateShippingBar();
    bindSubscribeToggle();
    bindCrossSell();
    bindBundleUp();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
